import React from 'react';
import LoadingStyle from './style';
import { Spin } from 'antd';

const Loading = () => {
    return (
        <LoadingStyle>
            <Spin size="large" />
        </LoadingStyle>
    );
};

export default Loading;
